export default __webpack_public_path__ + "static/media/2023_VanNuland_et_al_2023_JEcol.e102a784.pdf";